import { removeFcmToken } from 'firebase/setupFirebase'
import { api } from '..'

export const logout = () =>
  Promise.all([api.delete('/v1/accounts/sign-out'), removeFcmToken]).then(
    res => res[0],
  )
